import {get, post} from '../index'
export default {
  // 文章分类列表
  getArticleClassifyList (querys) {
    return get('/article/admin/adminArticleClassify/listAll', querys)
  },
  // 添加文章分类
  addArticleClassifyInfo (querys) {
    return post('/article/admin/adminArticleClassify/createOne', querys)
  },
  // 编辑文章分类
  editArticleClassifyInfo (querys) {
    return post('/article/admin/AdminArticleClassify/updateOne', querys)
  },
  // 上下架文章分类
  updateArticleClassifyInfo (querys) {
    return post('/article/admin/AdminArticleClassify/changeStatus', querys)
  },
  // 删除分类
  delArticleClassify (querys) {
    return post('/article/admin/AdminArticleClassify/changeDel', querys)
  },
  // 文章列表
  getArticleList (querys) {
    return get('/article/admin/adminArticle/listAll', querys)
  },
  // 员工文章列表
  getArticleStaffList (querys) {
    return get('/article/admin/adminArticle/listStaffArticle', querys)
  },
  // 添加文章
  addArticleInfo (querys) {
    return post('/article/admin/adminArticle/createOne', querys)
  },
  // 编辑文章
  editArticleInfo (querys) {
    return post('/article/admin/adminArticle/updateOne', querys)
  },
  // 文章详情回显
  getArticleDetail (querys) {
    return get('/article/admin/adminArticle/getOne', querys)
  },
  // 上下架、删除文章
  updateArticleInfo (querys) {
    return post('/article/admin/adminArticle/changeStatus', querys)
  },
  // 文章搜素下拉菜单的数据
  getArticleClassifyOptions () {
    return get('/article/admin/adminArticleClassify/listAllForSelect')
  },
  // 文章设置回显
  getArticleSettingInfo () {
    return get('/article/admin/adminArticleConfig/getOne')
  },
  // 文章设置
  settingArticleInfo (querys) {
    return post('/article/admin/adminArticleConfig/updateOne', querys)
  },
  // 获取分配获客文章列表
  getCustomerArticleList (querys) {
    return get('/article/admin/adminArticleConfig/staffList', querys)
  },
  // 授权获客文章
  updateCustomerArticle (querys) {
    return post('/article/admin/adminArticleConfig/addArticleUseYear', querys)
  },
  // 同步文章到文章库
  asyncArticleInfo (querys) {
    return post('/article/admin/adminArticle/syncStaffArticle', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/article.js